import { deleteFromLocalStorage } from "../utils/localstorage";
import { LocalStorageEnum } from "../utils/localstorage/LocalStorageEnum";

function isTokenExpired(token: string): boolean {
  
  try {
    // Remove "Bearer " if it exists
    const cleanedToken = token.startsWith("Bearer ")
      ? token.slice(7)
      : token;

    const payload = JSON.parse(atob(cleanedToken.split(".")[1])); // Decode the JWT payload
    const expirationTime = payload.exp * 1000; // Convert exp to milliseconds

    return expirationTime < Date.now();
  } catch (error) {
    // If token is malformed or decoding fails, remove and treat as expired
    deleteFromLocalStorage(LocalStorageEnum.TOKEN);
    return true;
  }
}

export default isTokenExpired;
